/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InventoryReportDTO } from './InventoryReportDTO';
import {
    InventoryReportDTOFromJSON,
    InventoryReportDTOFromJSONTyped,
    InventoryReportDTOToJSON,
} from './InventoryReportDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface InventoryReportPageDTO
 */
export interface InventoryReportPageDTO {
    /**
     * 
     * @type {Array<InventoryReportDTO>}
     * @memberof InventoryReportPageDTO
     */
    content?: Array<InventoryReportDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryReportPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryReportPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InventoryReportPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryReportPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof InventoryReportPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof InventoryReportPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof InventoryReportPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof InventoryReportPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryReportPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the InventoryReportPageDTO interface.
 */
export function instanceOfInventoryReportPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InventoryReportPageDTOFromJSON(json: any): InventoryReportPageDTO {
    return InventoryReportPageDTOFromJSONTyped(json, false);
}

export function InventoryReportPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryReportPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(InventoryReportDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function InventoryReportPageDTOToJSON(value?: InventoryReportPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(InventoryReportDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

